import { c as _c } from "react/compiler-runtime";
import MachineProvider from './components/machine-provider';
import Router from './pages/router';
import type { LivenessProps } from './types';
const AppWithMachine = t0 => {
  const $ = _c(9);
  const {
    actionKind,
    idvContext,
    onDone,
    onCustomSkip
  } = t0;
  let t1;
  if ($[0] !== idvContext) {
    t1 = {
      idvContext
    };
    $[0] = idvContext;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== actionKind || $[3] !== onCustomSkip || $[4] !== onDone) {
    t2 = <Router actionKind={actionKind} onDone={onDone} onCustomSkip={onCustomSkip} />;
    $[2] = actionKind;
    $[3] = onCustomSkip;
    $[4] = onDone;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <MachineProvider initialContext={t1}>{t2}</MachineProvider>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default AppWithMachine;